import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { AlternativeTransportLeftPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportLeftPanel";
import { AlternativeTransportRightPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportRightPanel";
import { useAlternativeTransportData } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/utils";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { SectionStateContent } from "shared/components/states/SectionStateContent";
import styled from "styled-components";

const PanelScroll = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
`;

const PanelRow = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 912px;
  display: flex;
  flex-direction: row;
  container-type: inline-size;
  container-name: altTransportPage;
`;

const PanelColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const AlternativeTransportDetails = () => {
  const { vehicleUuid } = useParams();
  const { status, data } = useAlternativeTransportData(vehicleUuid);
  const vehicle = data?.alternativeTransportResponseVehicle;

  const sectionState = useMemo(
    () => ({
      fetchStatus: status,
      isEmpty: !vehicle,
      emptyReason: "Fant ingen detaljer om bussen",
    }),
    [status, vehicle],
  );

  return (
    <>
      <TabsCenter />
      <SectionStateContent
        state={sectionState}
        size="lg"
        backgroundColor="bg.subtle"
        borderRadius="xs"
      >
        {vehicle && (
          <PanelScroll>
            <PanelRow>
              <PanelColumn>
                <AlternativeTransportLeftPanel vehicle={vehicle} />
              </PanelColumn>
              <PanelColumn>
                <AlternativeTransportRightPanel vehicle={vehicle} />
              </PanelColumn>
            </PanelRow>
          </PanelScroll>
        )}
      </SectionStateContent>
    </>
  );
};

export default withErrorBoundary(AlternativeTransportDetails);
